import React from "react";

type ToggleSwitchProps = {
  value: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  label?: string;
};

const FleetrifyToggleSwitch: React.FC<ToggleSwitchProps> = ({
  value,
  onChange,
  disabled = false,
  label,
}) => {
  return (
    <div className="flex items-center gap-2">
      {label && <span className="text-sm">{label}</span>}
      <div
        onClick={() => !disabled && onChange(!value)}
        className={`w-[50px] h-6 flex items-center rounded-full p-1 cursor-pointer transition-colors duration-300 ${
          value ? "bg-[#143887]" : "bg-gray-300"
        } ${disabled ? "opacity-50 cursor-not-allowed" : ""}`}
      >
        <div
          className={`bg-white w-5 h-5 rounded-full shadow-md transform transition-transform duration-300 ${
            value ? "translate-x-6" : "translate-x-0"
          }`}
        ></div>
      </div>
    </div>
  );
};

export default FleetrifyToggleSwitch;
